<template>
<div class="flex flex-col c-box">
	<div class="header-box">
	      <p class="nowrap" style="width: 90%; margin: 0px auto;">申报书预览</p>
	      <div class="close-box" @click="closePreview">x</div>
	</div>
	<div class="centent-box flex-1 flex">
		 <iframe
            width="100%"
            :src="sj(previewUrl)"
            name="123"
            scrolling-y="auto"
            frameborder="0"
            style="width: 100%; height: 100%; background: #fff"
          ></iframe>
	</div>
</div>
</template>

<script>
import { getAction,postAction, putAction,deleteAction} from "@/api/index";
import { baseURL } from "@/utils/request.js";
export default {
	data(){
		return{
		}
	},
	props: {
	    title: {
	      type: String,
	      default: '',
	     },
	     previewUrl: {
	      type: String,
	      default: 0
	     },
	},
	mounted(){
		
	},
	methods:{
		sj(url){
			return baseURL+url;
		},
		closePreview() {
	      this.$emit("closePreview");
	    },
	}
}

</script>

<style scoped lang="scss">
.c-box{
  width: 100%;
  height: 100%;
  /*background: url("../../assets/images/img49.png") no-repeat;
  background-size: 100% 100%;*/
  background-color: #fff;
  overflow-y: auto;
  .header-box{
  	  height: 60px;
	  line-height: 60px;
	  position: relative;
	  text-align: center;
	  background: #2155B5;
	  /*border-top-left-radius: 15px;
	  border-top-right-radius: 15px;*/
	  /*margin: 0px 19px 0px 9px;*/
	  font-size: 24px;
	  font-family: Microsoft YaHei;
	  font-weight: bold;
	  color: #fff;
  }
  .nowrap{
  	white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
   .close-box{
   	  position: absolute;
	    color: #fff;
	    font-size: 20px;
	    right: 3%;
	    cursor: pointer;
	    top: -2px;
   }
   .centent-box{
	   	margin: 0 0px 5px 0;
	    padding: 10px;
	    height: 80%;
   }
}
</style>